import { useEffect } from "react";
import { useLiveTutor } from "../../../hooks/LiveTutorProvider";

interface RepeatSentenceProps {
	expression: string;
	image?: { src: string; alt: string };
}

const RepeatSentence: React.FC<RepeatSentenceProps> = ({
	expression,
	image,
}) => {
	const { handleChat } = useLiveTutor();

	useEffect(() => {
		handleChat("Read the instruction/question.", false);
	}, []);

	return (
		<div className="flex flex-col items-center space-y-4 md:space-y-6 max-w-2xl mx-auto p-3 md:p-6 bg-gray-50 rounded-xl shadow-md">
			<h3 className="text-2xl md:text-2xl font-bold text-gray-800 text-center">
				Repeat the Sentence
			</h3>
			<p className="text-lg md:text-xl font-medium text-gray-800 mb-4 text-center">
				{expression}
			</p>
			{image && (
				<img
					src={image.src}
					alt={image.alt}
					className="w-full h-48 md:h-80 object-cover rounded-lg shadow-md"
				/>
			)}
		</div>
	);
};

export default RepeatSentence;
